import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {NzMessageService} from "ng-zorro-antd/message";
import {TranslateService} from "@root/shared/service/translate.service";

@Component({
  selector: 'host-widget-remark',
  templateUrl: 'remark.component.html',
  styleUrls: ['./remark.component.scss']
})

export class WidgetRemarkComponent implements OnInit {
  _note;
  @Input()
  get note() {
    return this._note;
  }
  set note(value) {
    this._note = value;
    this.form.patchValue({ note: value });
    // 切换的时候重置一下
    this.mode = 'view';
  }
  @Input() reservationCode;
  @Output() onSuccess = new EventEmitter();
  mode: 'view' | 'edit' = 'view';

  form: FormGroup = this.fb.group({
    note: null
  });

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private msg: NzMessageService,
    private t: TranslateService
  ) {
  }

  ngOnInit() {
  }

  onConfirm() {
    this.mode = 'view';
    this.requestSetNote();
  }

  onCancel () {
    this.mode = 'view';
    this.form.patchValue({ note: this.note });
  }

  private requestSetNote() {
    const params = {
      reservation_code: this.reservationCode,
      note: this.form.get('note').value
    };
    this.http.post('/api/reservation/add_note', params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.syncGet('success.save'));
        this.onSuccess.emit();
      }
    });
  }

}
